const addEventMixpanel = (currentEvent, templateSelected)  => {
   return {
      type: 'ADD_EVENT_MIXPANEL',
      payload: currentEvent,
      meta: {
        mixpanel: {
           event: 'addEvent',
           props: {
             sentFrom: "web",
             date: currentEvent.createdAt,
             event_djId: currentEvent.ownerId,
             event_djName: currentEvent.dj_name,
             eventDate: currentEvent.date,
             eventTitle: currentEvent.title,
             eventId: currentEvent.objectId,
             eventLocation: currentEvent.location,
             eventType: currentEvent.eventType,
             templateSelectedName: templateSelected.name,
             templateSelectedId: templateSelected.id,
             status: "Create Event",
           }
        }
      }
   }
}

export default addEventMixpanel;



// WEBPACK FOOTER //
// ./src/actions/mixpanel/addEventMixpanel.js